//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
import constant from '~/const';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      statuses: constant.traders.REQUISITE_TYPE_LIST,
      filters: {
        searchString: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        currency: [],
        paymentMethods: [],
        status: [],
      },
    };
  },

  computed: {
    ...mapState('tradersRequisites', ['filterLists']),

    ...mapState('tradersCurrencies', { currencies: 'data' }),
    ...mapState('tradersPaymentMethods', { paymentMethods: 'data' }),
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  created() {
    this.setFilters({});
  },

  methods: {
    ...mapActions('tradersRequisites', ['setFilters']),
  },
};
